export const groupQueryKeys = {
  all: ["group"] as const,
  as: (as: string) => [...groupQueryKeys.all, as] as const,
  getAs: (id: string, as: string) => [...groupQueryKeys.all, as, id] as const,
};

export default groupQueryKeys;
